function e(e,r){return r?e.replace(/\/+$/,"")+"/"+r.replace(/^\/+/,""):e}export{e as default};
